import React from 'react';

const legendItems = [
  { key: 'legend-negative', color: 'bg-price-negative', label: 'Negativ' },
  { key: 'legend-normal', color: 'bg-price-normal', label: '≤ 80 €/MWh' },
  { key: 'legend-high', color: 'bg-price-high', label: '> 80 €/MWh' },
  { key: 'legend-veryhigh', color: 'bg-price-very-high', label: '> 150 €/MWh' },
];

export default function PriceLegend() {
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-2 justify-end">
      {legendItems?.map((item) => (
        <div key={item?.key} className="flex items-center gap-1.5">
          <span className={`w-2.5 h-2.5 rounded-sm flex-shrink-0 ${item?.color}`} />
          <span className="text-xs text-muted-foreground">{item?.label}</span>
        </div>
      ))}
      <div className="flex items-center gap-1.5">
        <span className="w-2.5 h-2.5 rounded-sm flex-shrink-0 bg-price-normal border border-white" />
        <span className="text-xs text-muted-foreground">Aktuelle Stunde</span>
      </div>
    </div>
  );
}